export const newmexicoCountiesList = [
    'Bernalillo',
    'Catron',
    'Chaves',
    'Cibola',
    'Colfax',
    'Curry',
    'De Baca',
    'Dona Ana',
    'Eddy',
    'Grant',
    'Guadalupe',
    'Harding',
    'Hidalgo',
    'Lea',
    'Lincoln',
    'Los Alamos',
    'Luna',
    'McKinley',
    'Mora',
    'Otero',
    'Quay',
    'Rio Arriba',
    'Roosevelt',
    'Sandoval',
    'San Juan',
    'San Miguel',
    'Santa Fe',
    'Sierra',
    'Socorro',
    'Taos',
    'Torrance',
    'Union',
    'Valencia',
    ]